import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueDraggable from 'vue-draggable';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
//import router from './router'
Vue.config.productionTip = false
import { VueMaskDirective } from 'v-mask';

import VText from '@/components/field_types/VText.vue';
import router from '@/router/index.js';

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)

// import axios from 'axios'

// axios.interceptors.request.use((config) => {
//   // const token = localStorage.getItem('authToken')
//   // if (token) {
//   //   config.headers.Authorization = `Bearer ${token}`
//   // }
//   return config
// })

// // Response interceptor
// axios.interceptors.response.use((response) => {
//   // Handle the response here
//   return response
// }, (error) => {
//   // Handle errors here
//   console.error(error)
//   return Promise.reject(error)
// })
// Vue.prototype.$axios = axios;
Vue.directive('mask', VueMaskDirective);
// Vue.use(VueMask, {   // (!) custom placeholders support requires registration as a plugin to
//   placeholders: {
//     '#': null,       // passing `null` removes default placeholder, so `#` is treated as character
//     D: /\d/,         // define new placeholder
//     Я: /[\wа-яА-Я]/, // cyrillic letter as a placeholder
//   }
// })
const options = {
  position: "top-right",
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
};

Vue.use(Toast, options);
Vue.config.productionTip = false


Vue.use(VueDraggable);
Vue.component(VText);
new Vue({
  vuetify,
    router,
  render: h => h(App)
}).$mount('#app')
